// Auto-generated skeleton for ReviewDocumentReviewer

export const ReviewDocumentReviewer: Api.ReviewDocumentReviewer = {
  id: 0,
  user_id: 0,
  review_document_id: 0,
  access_level: 'read',
  status: 'pending',
  review_document: null,
  persons: [],
  created: null,
  updated: null,
};

